import "../components/StatusLightCircle.css";

export const getStatusLightCircleClassName = (light, withText = false) =>
    `status-light-circle status-light-circle--${light.color}${withText ? " status-light-circle--with-text" : ""}`;

export const createStatusLightCircle = (light, withText = false) => {
    const circle = document.createElement("span");
    circle.className = getStatusLightCircleClassName(light, withText);
    // The enclosing table cell already exposes the full status through aria-label.
    circle.setAttribute("aria-hidden", "true");
    if (withText) circle.textContent = light.colorName;
    return circle;
};
